export default {
  APROVADA: 'APROVADA',
  REPROVADA: 'REPROVADA',
  CANCELADA: 'CANCELADA',
  SOLICITACAO: 'SOLICITACAO'
}



// WEBPACK FOOTER //
// ./src/constants/ap/dadosEstado/suspensao.js